import { useState } from 'react'
import { Title } from '../../components/Title'
import ReactHowler from 'react-howler'
import ReactGA from 'react-ga4'
import { Link } from 'react-router-dom'

export const HomeChar = () => {
    const [isVoiceOn, setIsVoiceOn] = useState(false)

    const [voice, setVoice] = useState(1)
    const setCurrent = (e) => {
        setVoice(e)
    }
    return (
        <>
            <div className='my-20'>
                <Title title='Characters' />
                <div className='mx-auto relative mt-20 md:mt-0'>
                    {isVoiceOn && (
                        <ReactHowler
                            src={`${process.env.PUBLIC_URL}/voice/charvoice-0${voice}.wav`}
                            playing={isVoiceOn}
                            volume={0.3}
                            loop={false}
                            onEnd={() => setIsVoiceOn(false)}
                        />
                    )}
                    <div className='relative flex flex-col lg:flex-row items-end justify-center md:justify-between w-full mt-20 px-4'>
                        <div className='w-full lg:w-auto self-end lg:self-end px-2 lg:px-0'>
                            <div className='w-full flex flex-row lg:flex-col justify-center md:items-start items-center lg:items-center'>
                                <div className='relative -mr-4 lg:-mr-0'>
                                    <div className=''>
                                        <img
                                            className='mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/comment-bubble.png`}
                                            alt='comment bubble'
                                        />{' '}
                                    </div>
                                    <div className='max-w-[390px] absolute text-center top-1/4 -translate-y-1/4 left-1/2 -translate-x-1/2 w-[90%]'>
                                        <h1 className='text-shadow-char text-pbbrown font-sans chartext'>
                                            A girl who can speak with “Phantoms,” the spirits of the dead.
                                        </h1>{' '}
                                        <div className='w-4/5 lg:w-auto mx-auto'>
                                            <img
                                                className='mx-auto md:mt-1 mt-1 w-auto'
                                                src={`${process.env.PUBLIC_URL}/images/char-name-bubble-marona.png`}
                                                alt='marona'
                                            />
                                        </div>{' '}
                                        {voice === 1 && isVoiceOn === true ? (
                                            <button
                                                onClick={() => {
                                                    setIsVoiceOn(false)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 -translate-y-1/2 md:translate-y-0 lg:-translate-y-1/2'
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice_off.png`}
                                                    alt='voice off mark'
                                                />{' '}
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    ReactGA.event({
                                                        action: 'click',
                                                        event: 'play',
                                                        category: 'Character',
                                                        label: `Character Voice Marona`,
                                                    })
                                                    setCurrent(1)
                                                    setIsVoiceOn(true)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 -translate-y-1/2 md:translate-y-0 lg:-translate-y-1/2'
                                            >
                                                {' '}
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice.png`}
                                                    alt='voice mark'
                                                />{' '}
                                            </button>
                                        )}
                                    </div>{' '}
                                </div>
                                <div className='mx-auto'>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/characters/marona.png`}
                                        alt='marona kv'
                                    />
                                </div>
                            </div>{' '}
                        </div>{' '}
                        <div className='w-full lg:w-auto self-start lg:self-end px-2 lg:px-0'>
                            <div className='w-full flex flex-row-reverse lg:flex-col justify-center md:items-start items-center lg:items-center'>
                                <div className='relative -ml-40 lg:-ml-0'>
                                    <div className=''>
                                        <img
                                            className='hidden lg:block mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/comment-bubble.png`}
                                            alt='comment bubble'
                                        />{' '}
                                        <img
                                            width='399px'
                                            height='226px'
                                            className='lg:hidden block mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/characters/comment-bubble-mobile-l.png`}
                                            alt='comment bubble'
                                        />{' '}
                                    </div>
                                    <div className='max-w-[390px] absolute text-center top-1/4 -translate-y-1/4 left-1/2 -translate-x-1/2 w-[90%]'>
                                        <h1 className='text-shadow-char text-pbbrown font-sans chartext'>
                                            A young man who supports Marona, even in death.
                                        </h1>
                                        <div className='w-4/5 lg:w-auto mx-auto'>
                                            <img
                                                className='mx-auto md:mt-4 mt-1 w-auto'
                                                src={`${process.env.PUBLIC_URL}/images/char-name-bubble-ash.png`}
                                                alt='ash'
                                            />
                                        </div>{' '}
                                        {voice === 2 && isVoiceOn === true ? (
                                            <button
                                                onClick={() => {
                                                    setIsVoiceOn(false)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 '
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice_off.png`}
                                                    alt='voice off icon'
                                                />{' '}
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    ReactGA.event({
                                                        action: 'click',
                                                        event: 'play',
                                                        category: 'Character',
                                                        label: `Character Voice Ash`,
                                                    })
                                                    setCurrent(2)
                                                    setIsVoiceOn(true)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 '
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice.png`}
                                                    alt='voice icon'
                                                />{' '}
                                            </button>
                                        )}
                                    </div>{' '}
                                </div>
                                <div className='mx-auto'>
                                    <img src={`${process.env.PUBLIC_URL}/images/characters/ash.png`} alt='assets' />
                                </div>
                            </div>{' '}
                        </div>{' '}
                        <div className='w-full lg:w-auto lg:self-end px-2 lg:px-0'>
                            <div className='w-full flex flex-row lg:flex-col justify-center md:items-start items-center lg:items-center'>
                                <div className='relative -mr-8 lg:-mr-0'>
                                    <div className=''>
                                        <img
                                            className='mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/comment-bubble.png`}
                                            alt='A lonely Phantom girl who longs to reunite with her father.'
                                        />{' '}
                                    </div>
                                    <div className='max-w-[390px] absolute text-center top-1/4 -translate-y-1/4 left-1/2 -translate-x-1/2 w-[90%]'>
                                        <h1 className='text-shadow-char text-pbbrown font-sans chartext'>
                                            A lonely Phantom girl who longs to reunite with her father.
                                        </h1>
                                        <div className='w-4/5 lg:w-auto mx-auto'>
                                            <img
                                                className='mx-auto md:mt-1 mt-1 w-auto'
                                                src={`${process.env.PUBLIC_URL}/images/char-name-bubble-apricot.png`}
                                                alt='apricot'
                                            />
                                        </div>
                                        {voice === 3 && isVoiceOn === true ? (
                                            <button
                                                onClick={() => {
                                                    setIsVoiceOn(false)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 -translate-y-1/2 md:translate-y-0 lg:-translate-y-1/2'
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice_off.png`}
                                                    alt='voice off icon'
                                                />{' '}
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    ReactGA.event({
                                                        action: 'click',
                                                        event: 'play',
                                                        category: 'Character',
                                                        label: `Character Voice Apricot`,
                                                    })
                                                    setCurrent(3)
                                                    setIsVoiceOn(true)
                                                }}
                                                className='w-auto absolute right-0 translate-x-1/2 -translate-y-1/2 md:translate-y-0 lg:-translate-y-1/2'
                                            >
                                                <img
                                                    className='w-[7vw] md:w-full  mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/btn_voice.png`}
                                                    alt='voice icon'
                                                />{' '}
                                            </button>
                                        )}
                                    </div>{' '}
                                </div>
                                <div className='mx-auto'>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/characters/apricot.png`}
                                        alt='apricot key visusal'
                                    />
                                </div>
                            </div>{' '}
                        </div>{' '}
                    </div>{' '}
                </div>{' '}
                <Link to='/characters'>
                    <img
                        className='flex justify-center mx-auto mt-8'
                        src={`${process.env.PUBLIC_URL}/images/button-char-more.png`}
                        alt='more char info'
                    />{' '}
                </Link>
            </div>
        </>
    )
}
